import { render, staticRenderFns } from "./LoadingQuotation.vue?vue&type=template&id=345b4e25&scoped=true"
import script from "./LoadingQuotation.vue?vue&type=script&lang=js"
export * from "./LoadingQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b4e25",
  null
  
)

export default component.exports